import { useState } from "react"

/**
 * 클립보드 복사 가능한 코드 블록 — 엔드포인트 URL, 발급 키, curl 예시 등에 사용.
 */
export function CopyRow(props: { readonly value: string; readonly multiline?: boolean }) {
	const [copied, setCopied] = useState(false)

	async function copy() {
		try {
			await navigator.clipboard.writeText(props.value)
			setCopied(true)
			setTimeout(() => setCopied(false), 1500)
		} catch {
			/* noop */
		}
	}

	return (
		<div className="code-block">
			<pre className="code" style={props.multiline ? undefined : { whiteSpace: "nowrap", overflowX: "auto" }}>
				{props.value}
			</pre>
			<button type="button" className="code-copy" onClick={copy}>
				{copied ? "복사됨" : "복사"}
			</button>
		</div>
	)
}
